import Banner from '@/components/banner'
import Faq from '@/components/faq/faq'
import { generalFaqData, nbnFaqData } from '@/components/faq/faqData'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/faqs')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Banner
        backgroundUrl="/img/contact_us.png"
        containerStyle="min-h-[450px] lg:min-h-[550px]"
      />

      <div className="breakpoint-container px-0 md:px-4 -mt-[210px] z-10 mb-20">
        <h1 className="text-6xl text-white font-bold mb-15 px-4 md:px-0">
          FAQs
        </h1>

        <div className="card">
          <h2 className="text-3xl font-bold mb-6">General</h2>

          <div className="flex flex-col gap-5">
            {generalFaqData.map((data, index) => (
              <Faq key={index} title={data.question}>
                <div className="mt-2">{data.answer}</div>
              </Faq>
            ))}
          </div>

          <h2 className="text-3xl font-bold my-6">Nbn™</h2>

          <div className="flex flex-col gap-5">
            {nbnFaqData.map((data, index) => (
              <Faq key={index} title={data.question}>
                <div className="mt-2">{data.answer}</div>
              </Faq>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
